import { useState, useContext } from 'react';

import { ExperienceContext } from '@thd-nucleus/experience-context';

import { postDeclineClearVerification } from '../utils/api';

export const useDenyClearVerification = ({ state }) => {
  const [data, setData] = useState({});
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [isExecutable, setIsExecutable] = useState(true);

  const ctx = useContext(ExperienceContext);
  const { hosts } = ctx;
  const { apionline } = hosts || {};

  const executeRequest = async () => {
    if (isExecutable) {
      setLoading(true);
      setIsExecutable(false);
      try {
        const result = await postDeclineClearVerification({ host: apionline, state });
        setData(result);
        setError('');
      } catch (err) {
        setError(err.message || 'Unexpected Error');
        setData({});
        setIsExecutable(true);
      } finally {
        setLoading(false);
      }
    } else {
      setData({ ...data });
    }
  };

  return {
    data,
    error,
    loading,
    executeRequest
  };
};
